module.exports = __webpack_public_path__ + "static/media/BreastCancer_FFE3921.40502766.jpg";